import React, { useState,useEffect } from 'react'
import "../LeftSide/Left.css"
import { AiOutlineHome } from "react-icons/ai"
import { AiOutlineSearch } from "react-icons/ai"
import { FiTrendingUp } from "react-icons/fi"
import { Link } from 'react-router-dom';
import { BsBookmark } from "react-icons/bs"
import { RiFileListLine } from "react-icons/ri"
import { FiSettings } from "react-icons/fi"
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import Profile from "../../assets/profile.jpg"
import anonymous from "../../assets/images/anonymous.jpg"

import Online from '../RightSide/RightComponents/Online/Online'
import { get } from '../../service/apiService';
import {
  API_BASE_URL,
  API_KEY,
  s3ApiUrl
} from '../../constants';
import axiosInstance from '../../axios'
const Left = ({member_id}) => {

  const [isInvited, setIsInvited] = useState(false);

  const [familyMembers, setFamilyMembers] = useState([]);
  const get_family_api_url= `family-members/`;
  const BASE_URL=window.location.origin;
  const sleep = ms => new Promise(
    resolve => setTimeout(resolve, ms)
  );
  useEffect(() => {
    const fetchDataAndSetFields = async () => {
  
        try {
          const responseData = await axiosInstance.get(API_BASE_URL+get_family_api_url+member_id);
          console.log(responseData)
          if(responseData && responseData.data){
            setFamilyMembers(prevState =>  responseData.data.data);
        }
      } catch (error) {
          console.error("An error occurred while fetching data:", error);
        }
      };
  
      fetchDataAndSetFields();

  }, []);

  
  const handleSmallInvite=(value)=>{
    if(value){
            try{      
                    const userData = JSON.parse(localStorage.getItem('userData')) || {}
                    const logged_in_user_id=userData.user_profile?.member_id || ''
                    const defaultCountryCode = '+91';
                    const data = {
                      logged_in_user: logged_in_user_id,
                      invite_list: [{countryCode: { value: defaultCountryCode, label: defaultCountryCode },mobile:value.mobile,}],
                    };
                  const response = axiosInstance.post(
                    `${API_BASE_URL}invite-friends/`,
                    data,
                    {
                      headers: {
                        'X-Api-Key': API_KEY,
                        'Content-Type': 'application/json',
                      },
                    }
                  );
                  if(response){
                    setIsInvited(true);

                  }
            // Handle response as needed
          } catch (error) {
            console.error('Error inviting friends:', error);
          }
        }
  }

  return (
    <div className="L-features">
      <div className="online-comp">
       <h2> Family Members</h2>
       
       {familyMembers.map((value,id)=>(
        
                  <div className='online-people'>
                            <a href={BASE_URL+"/profile/"+value.member_id} > <img src={value.profile_pic?s3ApiUrl+value.profile_pic:anonymous} alt /></a>
                            <div> <b> <p><a href={BASE_URL+"/profile/"+value.member_id}>{value.first_name}</a></p></b></div>
                            <div className="button-container-invite">
                                    <button  hidden={value.hidden} onClick={() => handleSmallInvite(value)}>{isInvited ? 'Invited' : 'Invite'}</button>
                            </div>
                    </div>

      ))} 
      </div>
      </div>
  )
}

export default Left